module.exports = {
    "Clear search": `Vymaza\u{165} vyh\u{13E}ad\xe1vanie`
};


//# sourceMappingURL=sk-SK.main.js.map
